const DEV_DEVICE_WHITELIST = '/dev-device-whitelist';

export const ROUTE_HOME_DEV_DEVICE_WHITELIST = DEV_DEVICE_WHITELIST + '/home';

export const logDeviceWhitelistRoutes = [ROUTE_HOME_DEV_DEVICE_WHITELIST];